import { useParams, Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CategoryHero from './components/CategoryHero';
import CategoryTabs from './components/CategoryTabs';
import ArticleList from './components/ArticleList';
import { getArticlesByCategory } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const categorySlug = slug || 'chigua-qianxian';
  const articles = getArticlesByCategory(categorySlug);
  const category = categories.find((c) => c.slug === categorySlug);

  const categoryName = category?.name || '分类';
  const categoryDesc = category?.description || '';

  return (
    <>
      <SEOHead
        title={`${categoryName} | 今日看料网 - ${categoryDesc}`}
        description={`今日看料${categoryName}频道——${categoryDesc}。聚合最新最热的${categoryName}相关资讯，吃瓜群众的一线热点追踪站。`}
        keywords={`${categoryName},今日看料,吃瓜一线,热点追踪,娱乐资讯`}
        canonicalUrl={`https://www.jinrikankan.com/category/${categorySlug}`}
        breadcrumbItems={[
          { name: '首页', url: 'https://www.jinrikankan.com/' },
          { name: categoryName, url: `https://www.jinrikankan.com/category/${categorySlug}` },
        ]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <CategoryHero categorySlug={categorySlug} />
          <CategoryTabs activeSlug={categorySlug} />

          <section className="py-10 md:py-14">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex items-end justify-between mb-6 md:mb-8">
                <div>
                  <p className="text-xs text-foreground-500 font-medium tracking-widest uppercase mb-1">
                    Articles in Category
                  </p>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                    {categoryName} <span className="text-foreground-500 text-base font-normal">· {articles.length}篇</span>
                  </h2>
                </div>
              </div>
              <ArticleList articles={articles} />
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}